import React from 'react';
import PropTypes from 'prop-types';
import { ShieldAlert } from 'lucide-react';
import { getOrgType } from '../authUtils';

function OrgTypeRoute({ allowedOrgTypes, children }) {
  const orgType = getOrgType();

  if (orgType !== null && Array.isArray(allowedOrgTypes) && allowedOrgTypes.includes(orgType)) {
    return children;
  }

  return (
    <div className="flex h-full items-center justify-center p-6">
      <div className="w-full max-w-md space-y-6 text-center">
        <div className="flex justify-center">
          <div className="rounded-full bg-destructive/10 p-6">
            <ShieldAlert className="h-16 w-16 text-destructive" />
          </div>
        </div>

        <div className="space-y-2">
          <h1 className="text-3xl font-bold tracking-tight">Access Denied</h1>
          <p className="text-muted-foreground">
            You do not have permission to view this page.
          </p>
        </div>

        <div className="space-y-3 pt-4">
          <p className="text-sm text-muted-foreground">
            If you believe you should have access to this page, please contact your administrator.
          </p>
        </div>
      </div>
    </div>
  );
}

OrgTypeRoute.propTypes = {
  allowedOrgTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  children: PropTypes.node.isRequired,
};

export { OrgTypeRoute };
